import { ErrorLogComponent } from '@cian/error-log-component';
import { useDeviceType } from '@cian/ui-kit';
import loadable from '@loadable/component';
import Cookies from 'js-cookie';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useIsOnboardingEnabled } from './useIsOnboardingEnabled';
import { ONBOARDING_FIRST_VISIT_COOKIE_NAME } from '../../constants/cookies';
import { AUD_MOBILE_CLEAN_FIRST_SESSION } from '../../constants/experiments';
import { selectExperiments } from '../../selectors/experiments';
import { useApplicationContext } from '../../utils/applicationContext';
import { isExperimentActive } from '../../utils/experiments';

const OnboardingContainerLoadable = loadable(() => import('./OnboardingContainerLoadable'), {
  resolveComponent: module => module.OnboardingContainer,
});

export function OnboardingContainer() {
  const ctx = useApplicationContext();
  const isEnabled = useIsOnboardingEnabled();
  const experiments = useSelector(selectExperiments);
  const isCleanFirstSessionEnabled = isExperimentActive(experiments, AUD_MOBILE_CLEAN_FIRST_SESSION, 'B');
  const isMobile = useDeviceType() === 'phone';

  React.useMemo(() => {
    if (!isCleanFirstSessionEnabled || !isMobile) {
      return;
    }
    if (Cookies.get(ONBOARDING_FIRST_VISIT_COOKIE_NAME) != null) {
      return;
    }
    Cookies.set(ONBOARDING_FIRST_VISIT_COOKIE_NAME, String(Date.now()), {
      domain: '.cian.ru',
      expires: 365,
    });
  }, [isCleanFirstSessionEnabled, isMobile]);

  if (!isEnabled) {
    return null;
  }

  return (
    <ErrorLogComponent logger={ctx.logger}>
      <OnboardingContainerLoadable />
    </ErrorLogComponent>
  );
}
